import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const addBillingAccountDialogStyle = () => ({
	bodyWrapper: {
		width: '300px',
		margin: '30px auto 60px',
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
		'& img': {
			marginRight: '8px',
		},
	},
	tab: {
		marginTop: '40px',
		minHeight: '305px',
	},
	verificationTabText: {
		marginBottom: '20px',
	},
	resendText: {
		marginTop: '20px',
	},
});

export default addBillingAccountDialogStyle;
